import { Component, OnChanges, OnInit, SimpleChanges } from '@angular/core'
import { IcosPaginationProps } from './pagination.props'

@Component({
  selector: 'icos-pagination',
  template: `
    <div class="icos-pagination" [class.icos-pagination--small]="small">
      <span class="icos-pagination__total" *ngIf="showTotal">共 {{ total }} 条</span>
      <div class="icos-pagination__pages">
        <icos-pagination-btn dir="left" (next)="nextHandle($event)" *ngIf="showPrev" [disabled]="model <= 1">
        </icos-pagination-btn>
        <icos-pagination-pager [current]="model" [count]="pageCount" *ngIf="showPager" (next)="nextHandle($event)">
        </icos-pagination-pager>
        <icos-pagination-btn dir="right" (next)="nextHandle($event)" *ngIf="showNext" [disabled]="model === pageCount">
        </icos-pagination-btn>
      </div>
      <div class="icos-pagination__option" *ngIf="showJumper || showSize">
        <icos-pagination-jump *ngIf="showJumper" [model]="model" [max]="pageCount" (next)="nextHandle($event)">
        </icos-pagination-jump>

        <icos-pagination-size
          *ngIf="showSize"
          [model]="pageSize"
          [sizes]="pageSizes"
          (modelChange)="updatePageSize($event)"
        >
        </icos-pagination-size>
      </div>
    </div>
  `
})
export class IcosPagination extends IcosPaginationProps implements OnInit, OnChanges {
  showPager: boolean = true
  showPrev: boolean = true
  showNext: boolean = true
  showTotal: boolean = true
  showSize: boolean = true
  showJumper: boolean = true

  static showLayout(IcosName: string, layout: string[]): boolean {
    const member: string = layout.find(name => name === IcosName)
    return !!member
  }

  constructor() {
    super()
  }

  nextHandle(step: number): void {
    const nextPage: number = this.model + step
    this.model = nextPage < 1 ? 1 : nextPage > this.total ? this.total : nextPage
    this.modelChange.emit(this.model)
  }

  updatePageSize(nextPageSize: number): void {
    this.pageCount = Math.ceil(this.total / nextPageSize)
    this.model = 1
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!changes) return
    if (changes.total && changes.total.isFirstChange()) return
    this.updateLayout()
  }

  ngOnInit(): void {
    if (!this.pageCount && this.total === undefined) {
      return console.warn('icos-pagination required [total]')
    }
    this.updateLayout()
  }

  private updateLayout(): void {
    if (this.total === undefined || this.total === null) {
      this.total = Math.round(this.pageCount * this.pageSize)
    }
    this.pageCount = Math.ceil(this.total / this.pageSize) || 1
    this.showPager = IcosPagination.showLayout('pager', this.layout)
    this.showPrev = IcosPagination.showLayout('prev', this.layout)
    this.showNext = IcosPagination.showLayout('next', this.layout)
    this.showTotal = IcosPagination.showLayout('total', this.layout)
    this.showSize = IcosPagination.showLayout('size', this.layout)
    this.showJumper = IcosPagination.showLayout('jumper', this.layout)
  }
}
